/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="105.55"
        height="90.92"
        viewBox="0 0 105.55 90.92"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M98 59.4a5.4 5.4 0 1 1 4.32 9.89 1.48 1.48 0 0 1-2-.77 1.51 1.51 0 0 1 .64-1.91l.13-.06a2.41 2.41 0 0 0-1.77-4.47l-.15.07a1.5 1.5 0 0 1-1.2-2.75Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M92.56 20.66a1.502 1.502 0 0 1 .15 3h-16.5a1.502 1.502 0 0 1-.14-3h16.49Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M84.46 12.56A1.5 1.5 0 0 1 86 13.92v.14l-.06 16a1.502 1.502 0 0 1-3 .14v-.15l.06-16a1.5 1.5 0 0 1 1.46-1.49ZM69.42 5.4a1.502 1.502 0 0 1 .14 3h-11a1.502 1.502 0 0 1-.15-3h11Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M64-.02a1.51 1.51 0 0 1 1.49 1.37v10.8A1.48 1.48 0 0 1 64 13.66a1.5 1.5 0 0 1-1.49-1.36V1.5A1.51 1.51 0 0 1 64-.02ZM69.82 38.65a1.502 1.502 0 0 1 .15 3H47.59a1.502 1.502 0 0 1-.15-3h22.38Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M58.8 27.63a1.5 1.5 0 0 1 1.49 1.35v.14l-.08 21.79a1.501 1.501 0 0 1-3 .13v-.14l.08-21.79a1.5 1.5 0 0 1 1.51-1.48Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M8.51 43.05a1.5 1.5 0 0 1 1.71-1.07h.15l13.21 3.8a1.51 1.51 0 0 1 1.07 1.68v.14L16.2 80.29a1.5 1.5 0 0 1-1.73 1.09h-.14l-13.24-3.8a1.5 1.5 0 0 1 .68-2.91h.14l11.74 3.34 7.7-29.77L9.54 44.9a1.49 1.49 0 0 1-1.06-1.71ZM70.6 71.65l-2.28.94-1.66.68-.9.35-.76.36-.73.27-.65.24-.55.19-.47.15-.26.08a16 16 0 0 1-5.55.46l-.47-.06-10.45-1.68-6.07-1a1.51 1.51 0 0 1 .34-3h.18l16.52 2.66a12.62 12.62 0 0 0 4.66-.31h.11l.38-.12.49-.16.79-.29 1.47-.57 1.17-.46 2.47-1 5.93-2.5a2.83 2.83 0 0 0-1.53-5.45h-.16a1.5 1.5 0 1 1-.84-2.88 5.84 5.84 0 0 1 3.82 11Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M28.57 50.59a23.33 23.33 0 0 1 10.65 1.79 56.83 56.83 0 0 1 7.27 4.11l.85.57.6.41 11.13 2.81h.44a34.58 34.58 0 0 0 7.38-.74l.77-.16 3-.66.62-.13.3-.06h.37a1.523 1.523 0 1 1 .53 3l-.42.06h-.12l-.66.14-3.09.69a37.67 37.67 0 0 1-9.37.92h-.31l-11.57-3.03a1.54 1.54 0 0 1-.49-.22l-.75-.52-.78-.52-.78-.51-.79-.49-.79-.48-.77-.46-.38-.22-.74-.42-.67-.39c-.7-.37-1.33-.69-1.88-.92a20.19 20.19 0 0 0-9.21-1.58A34.17 34.17 0 0 0 22 55.34a1.5 1.5 0 0 1-1.12-2.78 37.6 37.6 0 0 1 7.69-1.97ZM98.52 59.19a1.503 1.503 0 0 1 1.12 2.79l-.14.06L65 73.98a1.5 1.5 0 0 1-1.12-2.78h.14Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M103.41 67.03a1.51 1.51 0 0 1-.63 2l-11.9 6.29-6.77 3.54L78 82.05l-3.17 1.63-3.66 1.87-2.15 1.08-1.9.94-1.9.92-.7.33-.64.29-.89.4-.44.18-.25.1-.22.08-.18.07h-.15a21.07 21.07 0 0 1-14.94-1l-1-.37-1.51-.59-3-1.23-5.28-2.19-17.11-7.14-2.84-1.14-.42-.16a1.502 1.502 0 0 1 1.06-2.81l2 .8 4.6 1.9 17.12 7.16 2.89 1.18 1.78.73 1.5.59.89.34.37.14a18.23 18.23 0 0 0 12.62 1l.51-.14h.15l.29-.11.38-.16.62-.27 1-.45 1.43-.69 1.71-.84 3-1.53 4-2 4.1-2.11 4.51-2.34 10-5.25 9.1-4.81a1.5 1.5 0 0 1 2.13.58Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'HandWithThreePlusSignsIcon';

export default Icon;
